import {
  useDateTimeFormatter,
  useFormatCurrency,
  useFormatNumber,
  useFormatPercentage,
} from 'platform/locale';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

import type {GridPdfExportCallback} from 'features/eag-grid';

import {createServiceOrderPdfData} from '../utils/createServiceOrderPdfData';

const PDF_FILENAME = 'service-orders.pdf';
const BRAND = 'OMNETIC';

export function useServiceOrderPdfExport(): GridPdfExportCallback {
  const formatDateTime = useDateTimeFormatter();
  const formatCurrency = useFormatCurrency();
  const formatNumber = useFormatNumber();
  const formatPercentage = useFormatPercentage();

  return async (context, signal) => {
    signal.throwIfAborted();
    const records = createServiceOrderPdfData(context, {
      dateTime: (value) => formatDateTime('dateTimeShort', parseDate(value)),
      number: (value) => formatNumber(value, 0),
      currency: (amount, code) => formatCurrency(amount, code, 2),
      fuel: (value) => formatPercentage(value, 'nearest'),
      mileageUnit: i18n.t('general.metric.km'),
    });
    const selection = i18n.t('page.datagrid.labels.numberOfSelectedRows', {
      selectedRows: records.length,
    });
    const exportedAt = formatDateTime('dateTimeShort', context.exportedAt);
    const {createServiceOrderPdf} = await import('../utils/createServiceOrderPdf');
    signal.throwIfAborted();
    const bytes = await createServiceOrderPdf(
      {
        title: i18n.t('entity.order.labels.serviceOrders'),
        brand: BRAND,
        metadata: `${selection} | ${i18n.t('general.actions.export')} ${exportedAt}`,
        records,
      },
      signal
    );
    return {bytes, filename: PDF_FILENAME};
  };
}
